import { InjectionToken } from '@angular/core';
import { UsefulLinkConfig } from '../interfaces/useful-links.interface';

export const USEFUL_LINKS_CONFIG = new InjectionToken<UsefulLinkConfig>(
  'USEFUL_LINKS_CONFIG',
);
